import GroupsList from '../components/GroupsList';

export default function GroupsWorkspace() {
  return (
    <div className="px-8 py-8 w-full max-w-[1600px] 2xl:max-w-[1800px] mx-auto">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h1 className="text-2xl font-semibold">Geoclients</h1>
          <p className="text-slate-500 mt-1 max-w-2xl">
            Choose a client, then a market geoclient, to open scenarios and Current Staff Plans.
          </p>
        </div>
      </div>
      <GroupsList />
    </div>
  );
}
